///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2021 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

export const getShipperDistanceStyle = (shipperDistance, coyoteDistance) => {
  const higlightColorStyle = { color: "#B00020" };

  if (coyoteDistance > 1500) {
    if (Math.abs(shipperDistance - coyoteDistance) > 50) {
      return higlightColorStyle;
    }
  } else if (coyoteDistance > 750) {
    if (Math.abs(shipperDistance - coyoteDistance) > 30) {
      return higlightColorStyle;
    }
  } else if (coyoteDistance > 250) {
    if (Math.abs(shipperDistance - coyoteDistance) > 20) {
      return higlightColorStyle;
    }
  } else if (coyoteDistance >= 0) {
    if (Math.abs(shipperDistance - coyoteDistance) > 10) {
      return higlightColorStyle;
    }
  }
};

export default getShipperDistanceStyle;
